import styled from "styled-components";
import { Input, Select, DatePicker } from "antd";

// Styled Input Component
const StyledInput = styled(Input)`
  // line-height: 2.5714285714285714; 
  // border-radius: 3px; 
  font-family: 'Roboto', sans-serif;
  border-color: 1px solid #BDBDBD;
  color:black;

  &.ant-input {
    border: 1px solid #BDBDBD; /* Default border color */
    border-radius:2px;
    padding: 10px 16px;
    box-shadow: none; /* Remove default box-shadow */
    transition: border-color 0.3s ease, box-shadow 0.3s ease; /* Smooth transition for border color and shadow */
  }

  &.ant-input:hover,
  &.ant-input:focus {
    border-color: #FC350B; /* Border color on hover and focus */
    box-shadow: 0 0 0 1px rgba(255, 133, 192, 0.1); /* Optional: Pink shadow on focus */
  }

  &.ant-input:active,
  &.ant-input:focus-visible {
    border-color: #FC350B; /* Border color when active (clicked) */
    box-shadow: 0 0 0 1px rgba(255, 133, 192, 0.1); /* Optional: Pink shadow on focus */
  }

  .ant-input-prefix,
  .ant-input-suffix {
    color: #FC350B; /* Icon color if you have prefixes/suffixes */
  }
`;

const StyledPasswordInput = styled(Input.Password)`
  // line-height: 2.5714285714285714; 
  // border-radius: 3px;
  font-family: 'Roboto', sans-serif;
  border-color: 1px solid #BDBDBD;
  color:black;
  
  &.ant-input-password {
    box-shadow: none; /* Remove default box-shadow */
    border: 1px solid #BDBDBD; /* Default border color */
    border-radius:2px;
    padding: 10px 16px;
    outline: none; /* Remove default outline */
    transition: border-color 0.3s ease, box-shadow 0.3s ease; /* Smooth transition */
  }

  &.ant-input-password:hover,
  &.ant-input-password:focus {
    border-color: #FC350B; /* Border color on hover and focus */
    box-shadow: 0 0 0 1px rgba(255, 133, 192, 0.1); /* Optional: Pink shadow on focus */
    outline: none; /* Remove outline on focus */
  }

  &.ant-input-password:active,
  &.ant-input-password:focus-visible {
    border-color: #FC350B; /* Border color when active (clicked) */
    box-shadow: 0 0 0 1px rgba(255, 133, 192, 0.1); /* Optional: Pink shadow on focus */
    outline: none; /* Remove outline on focus-visible */
  }

  .ant-input-prefix,
  .ant-input-suffix {
    color: #FC350B; /* Icon color if you have prefixes/suffixes */
  }
`;


const StyledSelect = styled(Select)`
  &.ant-select {
    .ant-select-selector {
      border: 1px solid #BDBDBD !important;
      box-shadow: none !important;
      border-radius: 2px;
      padding: 6px 12px !important; /* Apply padding inside the select box */
      display: flex;
      align-items: center;
      height: 45px; /* To make sure padding affects the height */
    }
      
      /* Focus/Active state for border and shadow */
    &.ant-select-focused .ant-select-selector,
    &.ant-select-selector:focus,
    &.ant-select-selector:active {
      border-color: #FC350B !important;
      box-shadow: 0 0 0 1px rgba(255, 194, 224, 0.1) !important;
    }

    /* Open state for border and shadow */
    &.ant-select-open .ant-select-selector {
      border-color: #FC350B !important;
      box-shadow: 0 0 0 1px rgba(255, 194, 224, 0.1) !important;
    }

    /* Arrow color when focused or open */
    .ant-select-arrow {
      color: lightgrey;
      transition: color 0.3s ease;
    }

    &.ant-select-focused .ant-select-arrow,
    &.ant-select-open .ant-select-arrow {
      color: #FC350B !important;
    }

    /* Styles for the selected item and hovered options */
    .ant-select-item-option-selected {
      background-color: #FC350B !important;
      color: white !important;
    }

    .ant-select-item-option-active {
      background-color: #ffd6eb !important;
      color: black !important;
    }
  }
`;


const StyledDatePicker = styled(DatePicker)`
  font-family: 'Roboto', sans-serif;
  border-color: #BDBDBD;
  color: black;
  width:200px;
  &.ant-picker {
    border: 1px solid #BDBDBD; /* Default border color */
    border-radius:2px;
    padding:6px 10px;
    box-shadow: none; /* Remove default box-shadow */
    transition: border-color 0.3s ease, box-shadow 0.3s ease; /* Smooth transition */
  }

  &.ant-picker:hover,
  &.ant-picker:focus {
    border-color: #FC350B; /* Border color on hover and focus */
    box-shadow: 0 0 0 1px rgba(255, 133, 192, 0.1); /* Optional: Pink shadow on focus */
  }

  &.ant-picker:active,
  &.ant-picker:focus-visible {
    border-color: #FC350B; /* Border color when active (clicked) */
    box-shadow: 0 0 0 1px rgba(255, 133, 192, 0.1); /* Optional: Pink shadow on focus */
  }

  .ant-picker-input {
    color: black; /* Input text color */
  }

  .ant-picker-suffix {
    color: lightgrey; /* Icon color */
  }

  .ant-picker-input:hover,
  .ant-picker-input:focus {
    color: #BDBDBD; /* Input text color on hover/focus */
  }

   @media (max-width: 768px) {
    width: 100%;
  }
`;

export { StyledInput, StyledPasswordInput, StyledSelect, StyledDatePicker };
